@let isBatteryConnectToPowerAndShuttingDownScreenShown =
  this.isBatteryConnectToPowerAndShuttingDownScreenShown();

<aiomed-blocking-modal
  [hasVirtualKeyboard]="hasVirtualKeyboard()"
  [isVisible]="
    isChargingScreenShown() ||
    isPoweringScreenShown() ||
    isBatteryConnectToPowerAndShuttingDownScreenShown
  "
  (pinCodeCorrectlyEntered)="pinCodeCorrectlyEntered.emit()">
  @if (isChargingScreenShown()) {
    <div class="login-low-charging__wrapper">
      <div class="login-low-charging__indicators">
        <lib-wifi-status-button
          [isOnline]="isOnline()"
          [isBlueMode]="true"
          (openWiFiNetworkSettings)="openWiFiNetworkSettings.emit()" />
        <lib-battery-status
          [batteryLevel]="batteryLevel()"
          [isDeviceCharging]="isDeviceCharging()"
          [isBlueMode]="true" />
      </div>
      <div class="login-low-charging__images">
        <img
          class="login-low-charging__images--battery"
          src="assets/images/low-battery.png"
          alt="low battery image" />
        <img
          class="login-low-charging__images--lightning"
          src="assets/images/lightning-white.svg"
          alt="lightning" />
      </div>
      <h4 class="login-low-charging__title">Battery too low to run</h4>
      <p class="login-low-charging__description">
        Please keep the tablet plugged in to keep going.
      </p>
    </div>
  }

  @if (
    isPoweringScreenShown() || isBatteryConnectToPowerAndShuttingDownScreenShown
  ) {
    <div class="login-low-charging--unplugged__wrapper">
      <div class="login-low-charging__indicators">
        <lib-wifi-status-button
          [isOnline]="isOnline()"
          [isBlueMode]="true"
          (openWiFiNetworkSettings)="openWiFiNetworkSettings.emit()" />
        <lib-battery-status
          [batteryLevel]="batteryLevel()"
          [isDeviceCharging]="isDeviceCharging()"
          [isBlueMode]="true" />
      </div>
      <img
        class="login-low-charging--unplugged--battery"
        src="assets/images/low-battery.png"
        alt="low battery image" />
      <h4 class="login-low-charging--unplugged__title">
        <span
          [class.larger]="isBatteryConnectToPowerAndShuttingDownScreenShown">
          NO BATTERY
        </span>
        <span> CONNECT TO POWER </span>
        @if (isBatteryConnectToPowerAndShuttingDownScreenShown) {
          <span>TABLET SHUTTING DOWN </span>
        }
      </h4>
      <img
        class="login-low-charging--unplugged--lightning"
        [class.shutting-down]="
          isBatteryConnectToPowerAndShuttingDownScreenShown
        "
        src="assets/images/lightning-white.svg"
        alt="lightning" />
    </div>
  }
</aiomed-blocking-modal>
